import React from 'react';
import { Col, Row } from 'react-bootstrap';

interface RoundedImageCardProps {
  img: string;
  headline: string;
  description: string;
}

const RoundedImageCard: React.FC<{ data: RoundedImageCardProps }> = ({ data }) => {
  const { headline, img, description } = data;
  return (
    <Row className="flex-md-column rounded-image">
      <Col id="image-wrapper">
        <img className={'img-fluid'} alt={''} src={img} />
      </Col>
      <Col id="content-wrapper">
        <h4>{headline}</h4>
        <p className="image-card-description">{description}</p>
      </Col>
    </Row>
  );
};

export { RoundedImageCard };
